export enum ObjectType {
    CONTACT = 'CONTACT',
    MULTI_CONTACT = 'MULTI_CONTACT',
    MULTI_PICKLIST = 'MULTI_PICKLIST',
    ABSTRACT_DATETIME = 'ABSTRACT_DATETIME',
    DATE = 'DATE',
    DURATION = 'DURATION'
}
